export const nabidka = [
    
]